import { render, staticRenderFns } from "./LKA.vue?vue&type=template&id=1941de6c&scoped=true&"
import script from "./LKA.vue?vue&type=script&lang=js&"
export * from "./LKA.vue?vue&type=script&lang=js&"
import style0 from "./LKA.vue?vue&type=style&index=0&id=1941de6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941de6c",
  null
  
)

export default component.exports